module.exports = __webpack_public_path__ + "static/img/pc1.d3ccc878.jpg";